import { buildPublicCDNUrl } from "@repo/utils/lib/url";
import type {
  IImageTransformationsProvider,
  ImageTransformationKind,
  SupportedImageTransformationsProvider,
} from "../../../types";

export class BunnyProvider implements IImageTransformationsProvider {
  identifier: SupportedImageTransformationsProvider = "bunny";

  private getBunnyBaseUrl(): URL {
    const baseUrl = process.env.NEXT_PUBLIC_BUNNY_CDN_BASE_URL;

    if (!baseUrl) {
      throw new Error(
        "NEXT_PUBLIC_BUNNY_CDN_BASE_URL is not defined while NEXT_PUBLIC_IMAGE_TRANSFORMATIONS_PROVIDER is set to `bunny`.",
      );
    }

    return new URL(baseUrl);
  }

  buildImageCDNUrl(
    key: string,
    kind: ImageTransformationKind = "original",
  ): string {
    if (kind === "original") {
      return buildPublicCDNUrl(key);
    }

    const baseUrl = this.getBunnyBaseUrl();
    baseUrl.pathname = `/${key}`;
    baseUrl.searchParams.append("class", kind);

    return baseUrl.toString();
  }

  convertToTransformationUrl(
    current: string,
    kind: ImageTransformationKind = "original",
  ): string {
    if (kind === "original") {
      return current;
    }

    const bunnyUrl = new URL(this.getBunnyBaseUrl());
    const currentUrl = new URL(current);
    bunnyUrl.pathname = currentUrl.pathname;
    bunnyUrl.searchParams.append("class", kind);

    return bunnyUrl.toString();
  }

  isTransformationUrl(url: string): boolean {
    const bunnyBaseUrl = this.getBunnyBaseUrl();
    return url.startsWith(bunnyBaseUrl.origin) && url.includes("class=");
  }
}

export const bunnyProvider = new BunnyProvider();
